import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
`;

const Card = styled.div`
  max-width: 520px;
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
`;

const Title = styled.h1`
  margin: 0 0 0.75rem;
  font-size: 1.25rem;
  color: #0f172a;
`;

const Message = styled.p`
  margin: 0 0 1rem;
  color: #475569;
  line-height: 1.5;
  font-size: 0.95rem;
`;

const Detail = styled.pre`
  margin: 0 0 1rem;
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  font-size: 0.78rem;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 120px;
  overflow: auto;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const Button = styled.button`
  border: none;
  border-radius: 8px;
  padding: 0.65rem 1rem;
  font-weight: 600;
  cursor: pointer;
  background: ${(p) => (p.$secondary ? '#f1f5f9' : '#10b981')};
  color: ${(p) => (p.$secondary ? '#0f172a' : '#fff')};
`;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[Flea] UI crash caught by ErrorBoundary:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  handleClearSiteData = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
      /* ignore */
    }
    window.location.href = '/login';
  };

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    const errorMessage = error?.message || String(error);

    return (
      <Wrap>
        <Card>
          <Title>Something went wrong loading Flea</Title>
          <Message>
            The page started to load but hit an unexpected error. Try refreshing, or open the site in a private
            window. If it keeps happening, clear site data for flea-marketplace.com and sign in again.
          </Message>
          {errorMessage ? (
            <Detail>{errorMessage}</Detail>
          ) : null}
          <Actions>
            <Button type="button" onClick={this.handleReload}>Refresh page</Button>
            <Button type="button" $secondary onClick={this.handleClearSiteData}>Clear site data & sign in</Button>
            <Button type="button" $secondary onClick={this.handleHome}>Go to homepage</Button>
          </Actions>
        </Card>
      </Wrap>
    );
  }
}
